module.exports = __webpack_public_path__ + "static/assets/3e18f31443f6c5b349f715eb58b98549.png";